<script setup lang="ts">
import type { ProductDocument } from "@/schemas/product-document";

defineProps<{ product: ProductDocument }>();
</script>

<template>
  <div class="flex flex-col gap-2 sm:flex-row sm:items-center">
    <ProductThumbnail :product="product" class="shrink-0" />
    <div class="">
      <ProductName :product="product" />
      <ProductPriceSimple :product="product" />
    </div>
    <slot :product="product" />
  </div>
</template>
